import React, { useEffect, useState } from "react"
import { Link } from "gatsby"
import { format } from "date-fns"
import createPersistedState from "use-persisted-state"

import { githubRender } from "~utils/rehype-render"

const Entry = ({ entry, microcopy }) => {
  const usePersistedState = createPersistedState(
    "com.box.developer.changelog.last_shown_at",
  )
  const [lastShownAt] = usePersistedState(null)
  const [isNew, setIsNew] = useState(false)

  useEffect(() => {
    const isNewEntry = Date.parse(entry.frontmatter.published_at) > Date.parse(lastShownAt)
    setIsNew(isNewEntry)
  }, [lastShownAt])

  return (
    <Link to={entry.path} data-new={isNew}>
      <span data-unread>{microcopy.text("changelog.unread", "unread")}</span>
      <time>
        {format(Date.parse(entry.frontmatter.published_at), "MMM do, Y")}
      </time>
      <header>{githubRender(entry.titleAst)}</header>
      <div data-labels>
        {entry.frontmatter.is_new_feature && (
          <span data-type="new">
            {microcopy.text("changelog.levels.short.is_new_feature")}
          </span>
        )}
        {entry.frontmatter.is_impactful && (
          <span data-type="impactful">
            {microcopy.text("changelog.levels.short.is_impactful")}
          </span>
        )}
        {entry.frontmatter.applies_to.map((label) => (
          <span key={label} data-type="label">
            {microcopy.text(`changelog.labels.short.${label}`)}
          </span>
        ))}
      </div>
    </Link>
  )
}

export default Entry
